import axios from 'axios';

interface Address {
  unit?: string;
  streetnumber?: string;
  streetaddress?: string;
  pobox?: string;
  city?: string;
  province?: string;
  postalcode?: string;
}

let _getProvincesPromise: Promise<string[]> | undefined;
let _provincesCache: string[] | undefined;
const getProvinces = async (forceRefresh?: boolean) => {
  if (_provincesCache && !forceRefresh) {
    return _provincesCache;
  } else if (!_getProvincesPromise || forceRefresh) {
    _provincesCache = undefined;
    _getProvincesPromise = new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.get<string[]>('/common/provinces.php');
        _provincesCache = resp.data;
        resolve(_provincesCache);
      } catch (error) {
        reject(error);
      }
    });
  }
  return await _getProvincesPromise;
};

export { Address, getProvinces };
